// components/WelcomeBanner/index.js
import WelcomeBanner from './WelcomeBanner';

export default WelcomeBanner;
